.container {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
}

.separator {
    flex-grow: 1;
}